/**
 * Handles opening and closing the Add to Calendar modal.
 * To use this, you need a button with class 'js-add-to-calendar' to open the modal
 * and a modal with a unique ID specified in the button's `data-modal-id` attribute.
 */
export const initializeAddToCalendarButtons = () => {
    const openButtons = document.querySelectorAll('.js-add-to-calendar');

    openButtons.forEach(button => {
        const modalId = button.getAttribute('data-modal-id');
        const modal = document.getElementById(modalId);

        if (!modal) {
            return;
        }

        const closeButton = modal.querySelector('.js-close-modal');

        button.addEventListener('click', () => {
            modal.classList.add('modal-open');
        });

        closeButton?.addEventListener('click', () => {
            modal.classList.remove('modal-open');
        });

        // Close modal when clicking outside the modal box
        modal.addEventListener('click', (event) => {
            if (event.target === modal) {
                modal.classList.remove('modal-open');
            }
        });
    });
};
